import { createSlice } from '@reduxjs/toolkit';
import { handleRequestThunk } from '../../handleRequestThunk';
import { getCarTechData } from './carThunks';
import { commonInitialState } from '../../../../utils/common/commonInitialState';
import { clearCarKey } from '../../sell/sellKeys';
const SLICE_NAME = 'techData';

export const techDataSlice = createSlice({
    name: SLICE_NAME,
    initialState: structuredClone(commonInitialState),
    reducers: {
        clearCarTechData(state) {
            state.data = [];
        },
    },
    extraReducers: (builder) => {
        handleRequestThunk({ builder, request: getCarTechData });
        builder.addCase(clearCarKey, () => commonInitialState);
    },
});

export const { clearCarTechData } = techDataSlice.actions;

export const selectCarTechDataLoading = (state) =>
    state.autoData.techData.isLoading;

export const techData = techDataSlice.reducer;
